import type { DocumentFormValues } from '../../model/schemas';
import type { DocumentResource } from '../../model/types';

export function documentResourceToFormValues(
  doc: DocumentResource
): DocumentFormValues {
  return {
    documentId: doc.documentId,
    fileName: doc.fileName,
    fileUrl: doc.fileUrl,
  };
}
